import React from "react"
import styled from "styled-components"

export const Main = ({ children }) => {
  return <Article>{children}</Article>
}

const Article = styled.main`
  grid-column: 1 / -1;
  width: min(48rem, calc(100% - 2.5rem));
  margin: 0 auto 3rem;
`
